export default __webpack_public_path__ + "static/media/moon.ea8d9d47.png";